<template>
  <div class="imageDiv">
    <ImageLoader
        class="image"
        :src="asyncImageSrc != null ? asyncImageSrc : ''" />
  </div>
</template>

<style scoped>
.imageDiv {
  padding: 15px;
  display: flex;
    justify-content: center;
    align-items: center
}

</style>

<script>

import * as config from '@/config'
import path from 'path'
import common from '@/utils/common'
import ImageLoader from '@/components/molecules/ImageLoader'

export default {
  name: 'ProductImage',
  components: {
    ImageLoader
  },
  props: {
    image: {
      type: Object,
      default: () => {}
    },
    productCode: {
      type: String,
      default: ''
    },
    colorCode: {
      type: String,
      default: ''
    },
    fileDataList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      imageLoaded: null
    }
  },
  asyncComputed: {
    async asyncImageSrc () {
      const returnValue = await this.loadImage()
      return returnValue
    }
  },
  methods: {
    async loadImage (reGetUrl = false) {
      if ((this.image || {}).isNew) {
        const resultBase64 = await new Promise((resolve) => {
          let fileReader = new FileReader()
          fileReader.onload = (e) => resolve(fileReader.result)
          const imageFileData = this.fileDataList.find((img) => img.id === this.image.id)
          fileReader.readAsDataURL(imageFileData.file)
        })
        return resultBase64
      }
      if (this.imageLoaded != null && reGetUrl === false) {
        // fetchでアクセス.
        const res = await fetch(this.imageLoaded.imageSignedUrl)
        if (res.ok) {
          // Blob形式でデータ取得.
          const blob = await res.blob()
          const returnUrl = (window.URL || window.webkitURL).createObjectURL(blob)
          return returnUrl
        }
      }
      const url = new URL(path.join(config.PRODUCT_IMAGE_URL, encodeURIComponent(this.productCode), encodeURIComponent(this.colorCode), this.image.no.toString()))
      const method = 'get'
      const response = await common.apiAxios(url, { method })
      let imageSignedUrl = null
      if (response.data.noImage) {
        // TODO:画像の連携が壊れているのでイメージ変更
        return require('@/assets/img/no-image.png')
      } else {
        imageSignedUrl = response.data.imageSignedUrl
      }
      // 署名付きURLの保存
      this.imageLoaded = {
        colorCode: this.colorCode,
        id: this.image.id,
        imageSignedUrl: imageSignedUrl
      }

      // fetchでアクセス.
      const res = await fetch(imageSignedUrl)
      // Blob形式でデータ取得.
      const blob = await res.blob()
      const returnUrl = (window.URL || window.webkitURL).createObjectURL(blob)
      return returnUrl
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/product/ProductImage.vue